import currency from "currency.js";

export function calculateDiscountAmount(price, discountPercentage) {
  return price - (price * discountPercentage / 100);
}

export function calculateDiscountPercentage(originalPrice, sellingPrice) {
  return Math.round((originalPrice - sellingPrice) / originalPrice * 100);
}

export function calculatePriceWithTax(price, tax) {
  return (currency(price).add(tax)).value;
}

export function calculateTax(price, taxPercentage = 7.5) {
  if(price === 0 || [0, 0.0, 0.00].includes(taxPercentage)) {
    return price;
  }

  return (price * (taxPercentage/100));
}

export function getRandomInteger(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isFloat(num) {
  return num % 1 !== 0;
}

export function toInteger(value) {
  return parseInt(value, 10);
}

/*
 * Works but currently not used since Intl.NumberFormat serves our purposes.

export function compactNumber(number, digits = 1) {
  const lookup = [
    { value: 1,    symbol: "" },
    { value: 1e0,  symbol: "" },
    { value: 1e3,  symbol: "k" },
    { value: 1e6,  symbol: "M" },
    { value: 1e9,  symbol: "B" }, // or for memory sizes "G"
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];

  if(!number) {
    return number;
  }

  const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
  const item = lookup.findLast(item => Math.abs(number) >= item.value);

  return (
    item
      ? (number / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol)
      : "0"
  );
}
*/
